module.exports = __webpack_public_path__ + "static/media/daifuku.f941b14b.jpg";